var map = {
	"./ion-accordion_2.entry.js": [
		73384,
		"common",
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-accordion_2_entry_js"
	],
	"./ion-action-sheet.entry.js": [
		43743,
		"common",
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-action-sheet_entry_js"
	],
	"./ion-alert.entry.js": [
		69354,
		"common",
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-alert_entry_js"
	],
	"./ion-app_8.entry.js": [
		54211,
		"common",
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-app_8_entry_js"
	],
	"./ion-avatar_3.entry.js": [
		2231,
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-avatar_3_entry_js"
	],
	"./ion-back-button.entry.js": [
		48893,
		"common",
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-back-button_entry_js"
	],
	"./ion-backdrop.entry.js": [
		21712,
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-backdrop_entry_js"
	],
	"./ion-breadcrumb_2.entry.js": [
		76679,
		"common",
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-breadcrumb_2_entry_js"
	],
	"./ion-button_2.entry.js": [
		49505,
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-button_2_entry_js"
	],
	"./ion-card_5.entry.js": [
		31267,
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-card_5_entry_js"
	],
	"./ion-checkbox.entry.js": [
		92349,
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-checkbox_entry_js"
	],
	"./ion-chip.entry.js": [
		43611,
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-chip_entry_js"
	],
	"./ion-col_3.entry.js": [
		27280,
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-col_3_entry_js"
	],
	"./ion-datetime-button.entry.js": [
		84974,
		"default-node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_data-caf38df0_js--53ac9a",
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-datetime-button_entry_js"
	],
	"./ion-datetime_3.entry.js": [
		85274,
		"default-node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_data-caf38df0_js--53ac9a",
		"common",
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-datetime_3_entry_js"
	],
	"./ion-fab_3.entry.js": [
		57679,
		"common",
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-fab_3_entry_js"
	],
	"./ion-img.entry.js": [
		8379,
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-img_entry_js"
	],
	"./ion-infinite-scroll_2.entry.js": [
		73894,
		"common",
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-infinite-scroll_2_entry_js"
	],
	"./ion-input.entry.js": [
		7332,
		"common",
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-input_entry_js"
	],
	"./ion-item-option_3.entry.js": [
		42808,
		"common",
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-item-option_3_entry_js"
	],
	"./ion-item_8.entry.js": [
		96118,
		"common",
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-item_8_entry_js"
	],
	"./ion-loading.entry.js": [
		22760,
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-loading_entry_js"
	],
	"./ion-menu_3.entry.js": [
		73646,
		"common",
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-menu_3_entry_js"
	],
	"./ion-modal.entry.js": [
		78309,
		"common",
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-modal_entry_js"
	],
	"./ion-nav_2.entry.js": [
		69883,
		"common",
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-nav_2_entry_js"
	],
	"./ion-picker-column-internal.entry.js": [
		72982,
		"common",
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-picker-column-interna-ed115c"
	],
	"./ion-picker-internal.entry.js": [
		12753,
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-picker-internal_entry_js"
	],
	"./ion-popover.entry.js": [
		62435,
		"common",
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-popover_entry_js"
	],
	"./ion-progress-bar.entry.js": [
		60257,
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-progress-bar_entry_js"
	],
	"./ion-radio_2.entry.js": [
		97383,
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-radio_2_entry_js"
	],
	"./ion-range.entry.js": [
		93389,
		"common",
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-range_entry_js"
	],
	"./ion-refresher_2.entry.js": [
		5267,
		"common",
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-refresher_2_entry_js"
	],
	"./ion-reorder_2.entry.js": [
		28291,
		"common",
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-reorder_2_entry_js"
	],
	"./ion-ripple-effect.entry.js": [
		64687,
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-ripple-effect_entry_js"
	],
	"./ion-route_4.entry.js": [
		77338,
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-route_4_entry_js"
	],
	"./ion-searchbar.entry.js": [
		13366,
		"common",
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-searchbar_entry_js"
	],
	"./ion-segment_2.entry.js": [
		26782,
		"common",
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-segment_2_entry_js"
	],
	"./ion-select_3.entry.js": [
		69645,
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-select_3_entry_js"
	],
	"./ion-slide_2.entry.js": [
		25612,
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-slide_2_entry_js"
	],
	"./ion-spinner.entry.js": [
		49407,
		"common",
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-spinner_entry_js"
	],
	"./ion-split-pane.entry.js": [
		27798,
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-split-pane_entry_js"
	],
	"./ion-tab-bar_2.entry.js": [
		85660,
		"common",
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-tab-bar_2_entry_js"
	],
	"./ion-tab_2.entry.js": [
		96680,
		"common",
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-tab_2_entry_js"
	],
	"./ion-text.entry.js": [
		66794,
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-text_entry_js"
	],
	"./ion-textarea.entry.js": [
		905,
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-textarea_entry_js"
	],
	"./ion-toast.entry.js": [
		39011,
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-toast_entry_js"
	],
	"./ion-toggle.entry.js": [
		50798,
		"common",
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-toggle_entry_js"
	],
	"./ion-virtual-scroll.entry.js": [
		50203,
		"node_modules_pnpm_ionic_core_6_7_5_node_modules_ionic_core_dist_esm_ion-virtual-scroll_entry_js"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 74773;
module.exports = webpackAsyncContext;